import { render, staticRenderFns } from "./RootOnboarding.vue?vue&type=template&id=2cb841c4&"
import script from "./RootOnboarding.vue?vue&type=script&lang=ts&"
export * from "./RootOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./RootOnboarding.vue?vue&type=style&index=0&id=2cb841c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports